module.exports = __webpack_public_path__ + "img/10-aos-example.b6bf160b.webp";